
<template>
  <div class="left_block branches">
    <p class="header">
      <router-link :to="'/branches'">
        <span class="link"> Все филиалы <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>
      {{ branchInfo.name }}
    </p>

    <BranchActions
      @edit="openBranchEditModal"
      :branch-info="branchInfo"
      @delete="deleteBranch"
      @commission-create="openCommissionModal"
    />

    <div v-if="activeTab === 0 && branchId !== 1">
      <p class="actions_header">
        <span class="left">Список комиссий</span>
      </p> 
    <CommissionsTable 
      :commissions-list="commissionsList"
      @delete="deleteCommission"
      @create="createCommission"
      @edit="editCommission"
      @commission-edit="openCommissionModal"
      @changePage="getCommissionsList"
      :isLoading="isLoading"
    />
    </div>
    <b-modal :active.sync="isCommissionModalShow" has-modal-card scroll="keep">
      <CommissionCreate 
        :commission="commissionToEdit"
        @close-modal="isCommissionModalShow = false"
        @create="createCommission"
        @edit="editCommission"
      />
    </b-modal>

    <b-modal @close="closeBranchEditModal" :active.sync="branchEditModal" has-modal-card scroll="keep">
      <BranchesCreate
        :modal-info="modal"
        @close-modal="closeBranchEditModal"
        @edit-branch="editBranch"
        :new-branch="newBranch"
      />
    </b-modal>
  </div>
</template>

<script>
import CommissionsTable from '@/components/admin/branches/CommissionsTable'
import CommissionCreate from '@/components/admin/branches/CommissionCreate'
import BranchesCreate from '@/components/admin/branches/BranchesCreate'
import BranchActions from '@/components/admin/branches/BranchActions'
import { toastInfo } from '../../lib/toastCfg'

export default {
  components: {
    BranchActions,
    BranchesCreate,
    CommissionsTable,
    CommissionCreate
  },
  data() {
    return {
      search: {
        text: '',
        category: 0
      },
      branchEditModal: false,
      isLoading: true,
      isCommissionModalShow: false,
      commissionToEdit: {
        name: '',
        members: [],
      },
      commissionSource: {},
      activeTab: 0,
      currentPage: 1,
      newBranch: {
        name: '',
        address: '',
        contact: '',
        id: ''
      },
      oldBranch: {
        name: '',
        address: '',
        contact: '',
        id: ''
      },
      modal: {
        header: 'Редактирование филиала',
        button: 'Сохранить',
        action: 'edit-branch',
        creation: false,
        required: false
      },
      courseAddModal: false,
      rows: {
        checked: []
      },
      CheckedCourses: {
        ids: []
      },
    }
  },
  mounted() {
    this.loadData()
    this.getCommissionsList()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === this.$route.name) {
      next()
      this.loadData()
    }
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    branchId() {
      return Number(this.$route.params.id)
    },
    branchInfo() {
      return this.$store.state.branches.branchInfo
    },
    modalCategoriesList() {
      return this.$store.state.categories.ModalCategoriesList
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    commissionsList() {
      return this.$store.state.branches.commissionsList
    },
  },
  methods: {
    loadData() {
      this.$axios2
        .get('branches/' + this.branchId)
        .then((resp) => {
          this.isLoading = false
          this.$store.commit('setBranchInfo', { list: resp.data })
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    },
    editBranch() {
      let request = {}
      Object.keys(this.newBranch).forEach((key) => {
        if (this.newBranch[key] != this.oldBranch[key]) {
          request[key] = this.newBranch[key]
        }
      })
      if (!Object.keys(request).length) {
        this.closeBranchEditModal()
        return
      }
      this.$axios2
        .post('branches/' + this.newBranch.id, request)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
          this.closeBranchEditModal()
        })
        .catch(this.$errorToast)
    },
    openBranchEditModal(info) {
      this.newBranch = {
        name: info.name,
        address: info.address,
        contact: info.contact,
        id: info.id
      }
      this.oldBranch = {
        name: info.name,
        address: info.address,
        contact: info.contact,
        id: info.id
      }
      this.branchEditModal = true
    },
    closeBranchEditModal() {
      this.branchEditModal = false
      this.newRegions = []
    },
    deleteBranch() {
      this.$axios2
        .delete('branches/' + this.branchId)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.$router.push('/branches')
        })
        .catch(this.$errorToast)
    },
    getCommissionsList(page = 1) {
      this.isLoading = true
      this.$axios2
      .get('commissions?branch_id=' + this.branchId + '&page=' + page)
      .then((resp) => {
        const data = {
            total: resp.data.total,
            data: resp.data.data.map((commission) => {
            return {
              ...commission,
              members: JSON.parse(commission.members) || [],
            }
          })
        }
      this.$store.commit('setCommissionsList', { list: data })
        this.isLoading = false
      })
      .catch(this.$errorToast)
      .finally(() => this.isLoading = false)
    },
    editCommission() {
      if (this.commissionToEdit.name === this.commissionSource.name) {
        delete this.commissionToEdit.name
      }
      const data = {
        ...this.commissionToEdit,
        members: JSON.stringify(this.commissionToEdit.members)
      }
      this.$axios2
      .post('commissions/' + this.commissionToEdit.id, data )
      .then(() => {
        this.isCommissionModalShow = false
        this.getCommissionsList() 
        this.$buefy.toast.open({
          message: 'Успешно',
          type: 'is-info',
          position: 'is-top-right',
          duration: 2000,
          queue: false
        })
      })
      .catch(this.$errorToast)
    },
    deleteCommission(commissionId) {
      this.$axios2
      .delete('commissions/' + commissionId)
      .then(() => {
        this.getCommissionsList()
        this.$buefy.toast.open({
          message: 'Успешно',
          type: 'is-info',
          position: 'is-top-right',
          duration: 2000,
          queue: false
        })
      })
      .catch(this.$errorToast)
    },
    createCommission() {
      const data = {
        ...this.commissionToEdit,
        branch_id: this.branchId,
        members: JSON.stringify(this.commissionToEdit.members)
      }
      this.$axios2
      .post('commissions/', data)
      .then(() => {
        this.isCommissionModalShow = false
        this.getCommissionsList()
        this.$buefy.toast.open({
          message: 'Успешно',
          type: 'is-info',
          position: 'is-top-right',
          duration: 2000,
          queue: false
        })
      })
      .catch(this.$errorToast)
    },
    openCommissionModal(commission) {
      if (commission) {
        this.commissionSource = commission
        this.commissionToEdit = {
          name: commission.name,
          members: commission.members.map(a => ({...a})),
          id: commission.id
        };
      } else {
        this.commissionToEdit = {
          name: '',
          members: [],
        };
      }
      this.isCommissionModalShow = true
    },
  }
}
</script>
